import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, ClipboardList, Bell, LogOut, Ship, ShieldCheck, BarChart3, Settings } from 'lucide-react';import { api } from '@/lib/api';

export default function Shell({ user, children }) {
  const nav = useNavigate();
  const initials = user.name.split(' ').map((x) => x[0]).join('');
  const roleLabel = user.role === 'corporate_hr' ? 'CORPORATE HR' : 'VESSEL HR';
  const roleName = user.role === 'corporate_hr' ? 'Corporate HR Manager' : 'Vessel HR Manager';
  const vessel = user.role === 'corporate_hr' ? 'All vessels' : user.vessel;

  return (
    <div className="app-shell">
      <aside>
        <div className="brand"><span className="brand-mark"><Ship size={18} /></span> FairWay <em>HR</em></div>
        <div className="workspace-label">WORKSPACE</div>
        <NavLink data-testid="nav-dashboard" to="/" end><LayoutDashboard size={17} /> Overview</NavLink>
        <NavLink data-testid="nav-cases" to="/cases"><ClipboardList size={17} /> Cases</NavLink>
        <NavLink data-testid="nav-crew" to="/crew"><Users size={17} /> Crew records</NavLink>
        <NavLink data-testid="nav-reminders" to="/reminders"><Bell size={17} /> Follow-ups</NavLink>
        <NavLink data-testid="nav-analytics" to="/analytics"><BarChart3 size={17} /> Trends</NavLink>
        {user.role === 'corporate_hr' && (
          <>
            <NavLink data-testid="nav-audit" to="/audit"><ShieldCheck size={17} /> Audit</NavLink>
            <NavLink data-testid="nav-admin" to="/admin"><Settings size={17} /> Admin</NavLink>
          </>
        )}
        <div className="aside-foot">
          <div className="security">
            <ShieldCheck size={18} />
            <span><strong>Private workspace</strong><small>Access is role controlled</small></span>
          </div>
          <button data-testid="logout-button" className="logout" onClick={async () => { await api('/auth/logout', { method: 'POST' }); nav('/login'); window.location.reload(); }}>
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <section className="main-area">
        <header>
          <div>
            <span className="eyebrow">{roleLabel}</span>
            <div className="vessel-select"><Ship size={15} />{vessel}</div>
          </div>
          <div className="header-user">
            <div className="avatar">{initials}</div>
            <div>
              <strong data-testid="user-name">{user.name}</strong>
              <small>{roleName}</small>
            </div>
          </div>
        </header>
        <div className="content">{children}</div>
      </section>
    </div>
  );
}
